







import { Component, Vue } from 'vue-property-decorator';
import StAndrewsVideoHolder from '@/components/fancy/video/VideoBackground.vue';
import Video from '@/assets/video/background_video.mp4';

@Component({
  components: {
    StAndrewsVideoHolder,
  },
})
export default class Minimal extends Vue {
  private videoUrl: string = Video;
}
